import { useEffect, useState } from "react"
import TextInput from "../commons/TextInput"
import { useAtom } from "jotai"
import { recipientIdAtom, showIndividualMessageBoxAtom, showMessageBoxAtom, userAtom } from "../../store"
import { addRecipient, getUserData, updateUserProfile } from "../../firebase/users"
import { addDoc, collection, onSnapshot, orderBy, query, where } from "firebase/firestore"
import { db } from "../../firebase/config"
import { formatDate } from "../../utils"

const SidebarIndividualChat = () => {
    const [messages, setMessages] = useState([])
    const [sentMessages, setSentMessages] = useState([])
    const [receivedMessages, setReceivedMessages] = useState([])
    const [userData, setUserData] = useAtom(userAtom)
    const [messageText, setMessageText] = useState('')
    const [showIndividualMessageBox, setShowIndividualMessageBox] = useAtom(showIndividualMessageBoxAtom)
    const [, setShowMessageBox] = useAtom(showMessageBoxAtom)
    const [recipientId, setRecipientId] = useAtom(recipientIdAtom)
    const [partyData, setPartyData] = useState(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        if (recipientId !== null)
            getUserData(recipientId).then(data => {
                setPartyData(data)
                setLoading(false)
            })
    }, [recipientId])

    useEffect(() => {
        let newMsgs = [...sentMessages, ...receivedMessages]

        newMsgs = newMsgs.sort((a, b) => {
            const aTime = a.timestamp.seconds * 1e9 + a.timestamp.nanoseconds
            const bTime = b.timestamp.seconds * 1e9 + b.timestamp.nanoseconds
            return aTime - bTime
        })

        setMessages(newMsgs)
    }, [sentMessages, receivedMessages])

    useEffect(() => {
        if (userData && userData.id) {
            setMessages([])

            const q1 = query(
                collection(db, "messages"),
                where("recipientId", "==", recipientId),
                where("senderId", "==", userData.id),
                // where("timestamp", ">=", afterTimestamp),
                orderBy("timestamp")
            )

            const q2 = query(
                collection(db, "messages"),
                where("recipientId", "==", userData.id),
                where("senderId", "==", recipientId),
                // where("timestamp", ">=", afterTimestamp),    
                orderBy("timestamp")
            )

            const unsubscribe1 = onSnapshot(q1, (snapshot) => {
                const msgs1 = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
                setSentMessages(msgs1)
            })

            const unsubscribe2 = onSnapshot(q2, (snapshot) => {
                const msgs2 = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
                setReceivedMessages(msgs2)
            })

            return () => {
                unsubscribe1()
                unsubscribe2()
            }
        }
    }, [recipientId, userData])

    const onChangeMessageText = (value) => {
        setMessageText(value)
    }

    const onKeyDown = (event) => {
        if (event.key === 'Enter') {
            sendMessage()
        }
    }

    const sendMessage = async () => {
        if (messageText === '') return

        setMessageText('')

        await addDoc(collection(db, "messages"), {
            text: messageText,
            senderId: userData.id,
            recipientId: recipientId,
            timestamp: new Date(),
            state: 'unread'
        })


        if (!userData.recipients || userData.recipients.findIndex(item => item.id === recipientId) === -1) {
            await addRecipient(userData.id, recipientId)
            await addRecipient(recipientId, userData.id)
            await getUpdatedUserData()
        }
    }

    const formatDate = (seconds) => {
        let date = new Date(seconds * 1000);

        const options = { hour: 'numeric', minute: 'numeric', hour12: true }
        const timeString = date.toLocaleTimeString('en-US', options)
        const dateString = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`

        return `${timeString} ${dateString}`
    }

    useEffect(() => {
        scrollToBottom()
    }, [messages])

    const scrollToBottom = () => {
        const element = document.querySelector("#message-box")
        if (element) element.scrollTop = element.scrollHeight
    }

    return (
        showIndividualMessageBox &&
        <>
            {!loading &&
                <div className="fixed right-0 z-[9999] bg-[#181818] md:w-[726px] w-full h-full md:px-6 py-8 max-md:top-[69px] border-l-[1px] border-gray">
                    <div className="flex justify-between max-md:hidden">
                        <div className="flex max-md:px-4">
                            <img src="/assets/icons/icon-logo.svg" alt="user" className="mr-3" />

                            <span className="uppercase text-white">Your Chats</span>
                        </div>

                        <button onClick={() => setShowIndividualMessageBox(false)}>
                            <img src="/assets/icons/icon-close-white.svg" alt="close" />
                        </button>
                    </div>

                    <hr className="border-gray my-6 max-md:hidden"></hr>

                    <div className="flex justify-between max-md:px-4" onClick={() => { setShowIndividualMessageBox(false), setShowMessageBox(true) }}>
                        <button className="flex items-center mb-6 text-white w-fit">
                            <svg width="4" height="8" viewBox="0 0 4 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.187825 3.14583L3.20866 0.125C3.25033 0.0833333 3.29546 0.0520833 3.34408 0.03125C3.39269 0.0104166 3.44477 -2.06415e-08 3.50033 -1.82131e-08C3.61144 -1.33563e-08 3.70866 0.0381944 3.79199 0.114583C3.87533 0.190972 3.91699 0.291667 3.91699 0.416667L3.91699 6.75C3.91699 6.875 3.87533 6.97569 3.79199 7.05208C3.70866 7.12847 3.61144 7.16667 3.50033 7.16667C3.47255 7.16667 3.37533 7.125 3.20866 7.04167L0.187825 4.02083C0.11838 3.95139 0.0697692 3.88194 0.0419913 3.8125C0.0142136 3.74306 0.000325043 3.66667 0.000325046 3.58333C0.00032505 3.5 0.0142137 3.42361 0.0419913 3.35417C0.0697692 3.28472 0.11838 3.21528 0.187825 3.14583Z" fill="#1AB6F9" />
                            </svg>

                            <span className="ml-2">Go Back</span>
                        </button>

                        <button className="md:hidden" onClick={() => setShowIndividualMessageBox(false)}>
                            <img src="/assets/icons/icon-close-white.svg" alt="close" />
                        </button>
                    </div>

                    <div className="flex mb-4 border-style-decoration max-md:mx-2 justify-between border-gray border-[1px] px-6 py-2 bg-[#222] text-white text-sm">
                        <div className="flex items-center">
                            <img src="/assets/avatars/default.png" className="w-10 h-10 mr-3" alt="user" />

                            {partyData.displayName}
                        </div>

                        <button className="border-style-decoration px-8 py-3">
                            View Profile
                        </button>
                    </div>

                    <hr className="md:hidden border-gray mx-8"></hr>

                    <div className="border-gray-100 md:border-[1px] md:px-6 px-2 pb-6 pt-1">
                        <div className="!h-[450px] overflow-auto nice-scrollbar mb-4" id="message-box">
                            {messages.map(msg =>
                                msg.senderId === userData.id ?
                                    <div className="flex justify-end mt-7" key={msg.id}>
                                        <div className="mr-7">
                                            <div className="bg-[#292929] border-gray border-[1px] w-full text-white text-sm px-4 py-4">
                                                <div className="text-[#7F8289] mb-2">
                                                    You
                                                </div>

                                                <p className="leading-[1.5em]">
                                                    {msg.text}
                                                </p>
                                            </div>

                                            <div className="text-end text-gray-100 text-xs mt-1">
                                                {formatDate(new Date(msg.timestamp.seconds))}
                                            </div>
                                        </div>

                                        <img src="/assets/avatars/default.png" className="w-12 h-12 mr-3" alt="user" />
                                    </div>
                                    :
                                    <div className="flex mt-7" key={msg.id}>
                                        <img src="/assets/avatars/default.png" className="w-12 h-12 mr-7" alt="user" />

                                        <div>
                                            <div className="bg-[#292929] border-gray border-[1px] w-full text-white text-sm px-4 py-4">
                                                <div className="text-[#7F8289] mb-2">
                                                    {partyData.displayName}
                                                </div>

                                                <p className="leading-[1.5em]">
                                                    {msg.text}
                                                </p>
                                            </div>

                                            <div className="text-gray-100 text-xs mt-1">
                                                {formatDate(new Date(msg.timestamp.seconds))}
                                            </div>
                                        </div>
                                    </div>
                            )}
                        </div>

                        <TextInput
                            divClassName="bg-white/5 backdrop-blur-sm !rounded-none !bg-transparent"
                            placeholder="Type here..."
                            inputClassName="placeholder:text-white/60"
                            onChange={onChangeMessageText}
                            onKeyDown={onKeyDown}
                            value={messageText}
                        // disabled={recipientId === 'all'}
                        />
                    </div>
                </div>}

            <div
                className="fixed max-md:hidden inset-0 z-[9998] bg-[#000] backdrop-blur-sm bg-opacity-75 transition-opacity"
                onClick={() => setShowIndividualMessageBox(false)}
            >
            </div>
        </>
    )
}

export default SidebarIndividualChat